import { useQuery } from "@tanstack/react-query";
import { api } from "../../api/client";
import type { components } from "../../api/schema.gen";

export type BondSchedule = components["schemas"]["BondScheduleDTO"];

export function useBondSchedule(
  secid: string,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ["bond-schedule", secid],
    queryFn: async ({ signal }) => {
      const { data, error } = await api.GET("/api/bond/{secid}/schedule", {
        signal,
        params: { path: { secid } },
      });
      if (error || !data) throw new Error(String(error ?? "no data"));
      return data;
    },
    // Расписание меняется редко (флоатер объявил купон) — час спокойно.
    staleTime: 60 * 60_000,
    enabled: options?.enabled ?? true,
  });
}
